
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  RqthRefusalRequest,
} from '../models';
import {
    RqthRefusalRequestFromJSON,
    RqthRefusalRequestToJSON,
} from '../models';

export interface RefuseRqthDeclarationRequest {
    freelancerAccountId: string;
    rqthRefusalRequest: RqthRefusalRequest;
}

export interface ValidateRqthDeclarationRequest {
    freelancerAccountId: string;
}

/**
 * 
 */
export class RqthAdminApi extends runtime.BaseAPI {

    /**
          */
    async refuseRqthDeclarationRaw(requestParameters: RefuseRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerAccountId'] == null) {
            throw new runtime.RequiredError(
                'freelancerAccountId',
                'Required parameter "freelancerAccountId" was null or undefined when calling refuseRqthDeclaration().'
            );
        }

        if (requestParameters['rqthRefusalRequest'] == null) {
            throw new runtime.RequiredError(
                'rqthRefusalRequest',
                'Required parameter "rqthRefusalRequest" was null or undefined when calling refuseRqthDeclaration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/rqth/accounts/{freelancerAccountId}/refuse`.replace(`{${"freelancerAccountId"}}`, encodeURIComponent(String(requestParameters['freelancerAccountId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RqthRefusalRequestToJSON(requestParameters['rqthRefusalRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async refuseRqthDeclaration(requestParameters: RefuseRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.refuseRqthDeclarationRaw(requestParameters, initOverrides);
    }

    /**
          */
    async validateRqthDeclarationRaw(requestParameters: ValidateRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerAccountId'] == null) {
            throw new runtime.RequiredError(
                'freelancerAccountId',
                'Required parameter "freelancerAccountId" was null or undefined when calling validateRqthDeclaration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/rqth/accounts/{freelancerAccountId}/validate`.replace(`{${"freelancerAccountId"}}`, encodeURIComponent(String(requestParameters['freelancerAccountId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async validateRqthDeclaration(requestParameters: ValidateRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.validateRqthDeclarationRaw(requestParameters, initOverrides);
    }

}
